var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoniepoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03228 17.8907H8.96772C4.7957 17.8801 2 17.0144 1.41936 16.48C0.806448 15.9349 0 13.1135 0 8.94539C0 4.78796 0.806448 1.95579 1.41936 1.41073C2 0.876369 4.80645 0.0106874 8.96772 0H9.03228C13.2043 0.0106874 16 0.876369 16.5807 1.41073C17.1936 1.95579 18 4.78796 18 8.94539C18 13.1027 17.1936 15.9349 16.5807 16.48C16 17.0251 13.2043 17.8907 9.03228 17.8907Z",
    fill: "#0357EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1505 9.47944L12.8064 5.30066H10.7311C10.7311 5.30066 9.15042 8.51758 9.01065 8.95577H8.98913L7.32247 5.30066H5.23646L4.89237 8.92367L4.60205 12.6002H5.87087C6.41925 12.6002 6.6343 12.3651 6.67731 11.7879C6.67731 11.7879 6.89236 8.42137 6.86011 7.92979H6.88161L6.94613 8.15417C7.03215 8.45347 8.21493 11.3284 8.21493 11.3284H9.77405C9.77405 11.3284 10.9569 8.49621 11.1074 7.92979H11.1289L11.3117 11.7879C11.3548 12.3651 11.5805 12.6002 12.1182 12.6002H13.3869L13.1505 9.47944Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoniepoint);
export default __webpack_public_path__ + "static/media/moniepoint.593a42b220070027d8be6d959a8dcb11.svg";
export { ForwardRef as ReactComponent };